var H = require("hogan.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "\n", H);return T; }();


//////////////////
// WEBPACK FOOTER
// ./web/views/spa-page.mustache
// module id = 869
// module chunks = 2